import { observer } from "mobx-react-lite";

import { Switch } from "@/components/switch";

interface ArrayTypeSwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const ArrayTypeSwitch = ({ disabled, ...rest }: ArrayTypeSwitchProps) => (
  <div className={`mt-2 flex items-center gap-2 pl-6 ${disabled ? "opacity-50" : ""}`}>
    <span className="text-xs text-gray-600">Composition</span>
    <Switch disabled={disabled} {...rest} />
    <span className="text-xs text-gray-600">Description</span>
  </div>
);

export default observer(ArrayTypeSwitch);
